import { createContext, useContext } from 'react'
import type { NavigationHelper } from './navigation'

export const NavigationContext = createContext<NavigationHelper | null>(null)

export const useNavigation = () => {
  const navigation = useContext(NavigationContext)
  if (!navigation) {
    throw new Error('useNavigation must be used within a NavigationProvider')
  }
  return navigation
}

// Helper hook for e2e tests
export const useNavigationHistory = () => {
  const navigation = useNavigation()
  return {
    getHistory: navigation.getHistory,
    clearHistory: navigation.clearHistory,
    getLastNavigation: navigation.getLastNavigation,
  }
}
